
import { Button, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Paper as MaterialPaper, Link, Paper, Box, Select, MenuItem, InputLabel, Tooltip } from '@material-ui/core';
import { Teacher } from '../../../interfaces/examiner/Teacher'
import React, { Fragment } from 'react';
import TeacherContainer from '../TeacherContainer';
import { Link as Link2 } from 'react-router-dom'
import '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import SavingIndicator from '../../../components/SavingIndicator';
import SaveCancelButtons from '../../../components/SaveCancelButtons';
import { Cancel } from '@material-ui/icons';
import { Student } from '../../../interfaces/teacher/Student';
import request, { isLoggedIn } from '../../../api';
import { Redirect } from 'react-router-dom';

interface Props {
  examId: string
  id: string
}

interface State {
  student:Student|null,
  saving:boolean
  canReset: boolean
  hasChanges: boolean
}

// Year group tooltips with country equivalents (kept in sync with StudentDetailsDialog)
const YEAR_GROUP_TOOLTIPS = {
  'Year Group A': 'Year Group A - Y9 in England and Wales, Y10 in Northern Ireland, S2 in Scotland or equivalent in your country (and in younger year groups)',
  'Year Group B': 'Year Group B - Y10 in England and Wales, Y11 in Northern Ireland, S3 in Scotland or equivalent in your country',
  'Year Group C': 'Year Group C - Y11 in England and Wales, Y12 in Northern Ireland, S4 in Scotland or equivalent in your country',
  'Year Group D': 'Year Group D - Y12 in England and Wales, Y13 in Northern Ireland, S5 in Scotland or equivalent in your country',
  'Year Group E': 'Year Group E - Y13 in England and Wales, Y14 in Northern Ireland, S6 in Scotland or equivalent in your country'
}

export default class TeacherStudentPage extends React.Component<Props, State> {

  constructor(props:Props) {

    super(props)

    this.state = {
      student: null,
      saving: false,
      canReset: true,
      hasChanges: false
    }
  }

  render() {

    let { student, saving, canReset } = this.state


    if(!isLoggedIn('teacher')) {
        return <Redirect to='/login' />
    }


    if(!student) {
        return <TeacherContainer heading={"Loading..."}>Loading...</TeacherContainer>
    }

    return (
        <TeacherContainer heading={student.username}>
            <SavingIndicator saving={saving} />
                <div><h2>{student.username}</h2></div>
                <Button onClick={this.handleResetPassword} color="secondary" variant="outlined" disabled={!canReset}>
                    Reset User Password
                </Button>
                {!canReset && <p>Password reset</p>}
                <TextField autoFocus margin="dense"
                    id="name" label="Name"
                    fullWidth defaultValue={student.name}
                    onChange={(e) => this.handleFieldChange('name', e)} />
                    <br /> <br /> <br />
                    <InputLabel id="yeargroup-label">Year Group</InputLabel>
                   <Select
                        required
                        label="Year Group"
                        value = {student.yearGroup}
                        onChange = {(e) => this.handleFieldChange('yearGroup', e)}
                    >
                        <MenuItem
                            key={"Year Group A"}
                            value={"Year Group A"}>
                              <Tooltip title={YEAR_GROUP_TOOLTIPS['Year Group A']} placement="right">
                                <div>Year Group A</div>
                              </Tooltip>
                        </MenuItem>
                        <MenuItem
                            key={"Year Group B"}
                            value={"Year Group B"}>
                              <Tooltip title={YEAR_GROUP_TOOLTIPS['Year Group B']} placement="right">
                                <div>Year Group B</div>
                              </Tooltip>
                        </MenuItem>
                        <MenuItem
                            key={"Year Group C"}
                            value={"Year Group C"}>
                              <Tooltip title={YEAR_GROUP_TOOLTIPS['Year Group C']} placement="right">
                                <div>Year Group C</div>
                              </Tooltip>
                        </MenuItem>
                        <MenuItem
                            key={"Year Group D"}
                            value={"Year Group D"}>
                              <Tooltip title={YEAR_GROUP_TOOLTIPS['Year Group D']} placement="right">
                                <div>Year Group D</div>
                              </Tooltip>
                        </MenuItem>
                        <MenuItem
                            key={"Year Group E"}
                            value={"Year Group E"}>
                              <Tooltip title={YEAR_GROUP_TOOLTIPS['Year Group E']} placement="right">
                                <div>Year Group E</div>
                              </Tooltip>
                        </MenuItem>
                    </Select>
                    <Box display="flex" justifyContent="flex-end" mt={2} mb={2}>
                      <Button component={Link2} to={`/teacher/exams/${this.props.examId}`} style={{ marginRight: 8 }}>Back</Button>
                      <SaveCancelButtons
                        onSave={this.handleSave}
                        onCancel={this.handleCancel}
                        saveLoading={saving}
                        saveDisabled={!this.state.hasChanges}
                      />
                    </Box>
        </TeacherContainer>
    )
  }

  componentDidMount() {

    this.reloadStudent()

  }

  private async reloadStudent() {

    let student = await (await request(`/api/teacher/exams/${this.props.examId}/students/` + this.props.id)).json()

    this.setState(prevState => ({ ...prevState, student }))
  }

    handleFieldChange = async (field:string, e:any) => {
      let student = this.state.student as Student
      let newStuednt:Student = { ...student, [field]: e.target.value }

      await this.setState(prevState => ({ ...prevState, student: newStuednt, hasChanges: true }))
    }

    handleResetPassword = async () => {
      await request(`/api/teacher/exams/${this.props.examId}/students/${this.props.id}/resetPassword`, {
        method: 'PUT'
      })
      this.setState(prevState => ({ ...prevState, canReset: false }))
    }


    async save() {
      await request(`/api/teacher/exams/${this.props.examId}/students/${this.props.id}`, {
          method: 'PUT',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(this.state.student)
      })
      await this.setState(prevState => ({ ...prevState, saving: false, hasChanges: false }))
  }

  handleSave = async () => {
    await this.setState(prevState => ({ ...prevState, saving: true }))
    await this.save()
  }

  handleCancel = async () => {
    // Reload the student data to discard changes
    await this.reloadStudent()
    await this.setState(prevState => ({ ...prevState, hasChanges: false }))
  }

}
